import "config.css";
import "reset.css";
import "base.css";
import "fonts.css";
import "../components/Shared/Constants/colors.css";
import "../components/Shared/Constants/fonts.css"

import widgets from "@/widgets/index";
import templates from "@/templates/index";

import { pagegrowlerConfigFrontend } from "../pagegrowler.config";
import { FullApp, MinimalApp } from "@/shared/Application";
import { NotificationsProvider } from "@/shared/Notifications/context";

function Application({ Component, pageProps }) {
  /* Se importan los widgets desde la aplicacion padre hacia la libreria */
  pageProps.widgets = widgets;
  pageProps.templates = templates;
  pageProps.lila_url = process.env.NEXT_PUBLIC_LILAX_URL;
  pageProps.pagegrowler_backend_url =
    process.env.NEXT_PUBLIC_PAGEGROWLER_BACKEND_URL;
  pageProps.pagegrowler_frontend_api_url = '';

  pageProps.matchConfig = pageProps.matchConfig || { query: {} };
  pageProps.externalConfig = pagegrowlerConfigFrontend;

  if (pageProps?.matchConfig?.template === "MinimalNews") {
    return (
      <NotificationsProvider>
        <MinimalApp pageProps={pageProps} Component={Component} />
      </NotificationsProvider>
    );
  }
  return (
    <NotificationsProvider>
      <FullApp pageProps={pageProps} Component={Component} />
    </NotificationsProvider>
  );
}
export default Application;
